import { createMotivo, findById, findMotivo, updateMotivo } from "@/api/motivosDeCancelamento";
import { MotivoCancelamento } from "@/models/MotivoCancelamento";
import { MotivosDeCancelamentoServiceAdapter } from "@/usecases/venda/adapter/MotivosDeCancelamentoServiceAdapter";
import { injectable } from "inversify-props";

@injectable()
export class MotivosDeCancelamentoService implements MotivosDeCancelamentoServiceAdapter{
	create = async (motivo: MotivoCancelamento) => await createMotivo(motivo)
	update = async (motivo: MotivoCancelamento) => await updateMotivo(motivo)
	find = async (params?: any) => await findMotivo(params)
	findById = async (id: string) => await findById(id)
}